import { cn } from '../../lib/cn';

export interface InfoCellProps {
  title: string;
  /** Rendered mono and muted beneath the title — VIN, code, protocol version. */
  subline?: string | null;
  className?: string;
}

/** The two-line table cell from plan §2.2: a title with a quiet mono sub-line. */
export const InfoCell = ({ title, subline, className }: InfoCellProps) => (
  <div className={cn('min-w-0', className)}>
    <p className="truncate font-medium text-foreground">{title}</p>
    {subline ? <p className="truncate font-mono text-xs text-muted-foreground">{subline}</p> : null}
  </div>
);
